import React, { useContext, useEffect, useState } from 'react'
import { DefaultDoctorInterface, DoctorInterface } from '../../types'
import { useSelector } from 'react-redux'
import { State } from '../../../../redux/store'
import { useParams } from 'react-router'
import { Timeout, formattedDate } from '../../../../functions/functions'
import { DefaultRegistrationForm, RegistrationForm, RegistrationFormContext } from './types'
import Section1 from './Section1'
import Section2 from './Section2'
import Section3 from './Section3'
import Section4 from './Section4'
import Section5 from './Section5'
import Section6 from './Section6'
import Section7 from './Section7'
import Section8 from './Section8'
import Section9 from './Section9'
import Section10 from './Section10'
import Section11 from './Section11'
import Section12 from './Section12'
import Section13 from './Section13'
import HeaderRegForm from './HeaderRegForm'
import ButtonElement from '../../../../HtmlComponents/ButtonElement'
import { EditRegFormApi } from '../../../../redux/regForm/regFormApiCalls'
import { useDispatch } from 'react-redux'
import { AboutDoctorContext } from '../types'
import { getDoctorsApi } from '../../../../redux/doctors/doctorApiCalls'

const RegistrationFormComponent = () => {
  const { doctors } = useSelector((state: State) => state.doctors)
  const { regForms } = useSelector((state: State) => state.regForm)
  const { doctorId } = useParams()

  const [RegNo, setRegNo] = useState("") // matricule
  const [fullName, setFullName] = useState("") // prenom
  const [yearOfBirth, setYearOfBirth] = useState("")
  const [placeOfBirth, setPlaceOfBirth] = useState("")
  const [sex, setSex] = useState("")
  const [telephone, setTelephone] = useState("")
  const [whatsapp, setWhatsapp] = useState("")
  const [email, setEmail] = useState("")
  const [current, setCurrent] = useState("")
  const [medecinType, setMedecinType] = useState("")
  const [origin, setOrigin] = useState("")
  const [inscriptionDate, setInscriptionDate] = useState(formattedDate(new Date().toString()))

  const [avatar, setAvatar] = useState<File | any>(null)
  const [password, setPassword] = useState("")
  const [speciality, setSpeciality] = useState("")
  const [cabinet, setCabinet] = useState<any>({  })
    
  useEffect(() => {
    const selectedDoctor: DoctorInterface = doctors.find((doctor: DoctorInterface) => doctor._id === doctorId) || DefaultDoctorInterface
    setRegNo(selectedDoctor.RegNo)
    setFullName(selectedDoctor.fullName)
    setYearOfBirth(selectedDoctor.yearOfBirth)
    setPlaceOfBirth(selectedDoctor.placeOfBirth)
    setSex(selectedDoctor.sex)
    setTelephone(selectedDoctor.contact.phone)
    setWhatsapp(selectedDoctor.contact.whatsapp)
    setEmail(selectedDoctor.contact.email)
    setCurrent(selectedDoctor.nationality?.current)
    setOrigin(selectedDoctor.nationality?.origin)
    setMedecinType(selectedDoctor.medecinType?._id)
    setInscriptionDate(formattedDate(selectedDoctor.inscriptionDate))
    setAvatar(selectedDoctor.avatar)
    setPassword("")
    setSpeciality(selectedDoctor.speciality)
    setCabinet({ value: selectedDoctor.cabinet?._id, label: selectedDoctor.cabinet?.name })
  }, [doctorId, doctors])

  const [practiceLocations, setPracticeLocations] = useState("") // 6
  const [maritalStatus, setMaritalStatus] = useState<string>("") // 8 Marié
  const [conjointDateOfBirth, setConjointDateOfBirth] = useState<string>("") // 9
  const [conjointPlaceOfBirth, setConjointPlaceOfBirth] = useState<string>("") // 9
  const [conjointProfession, setConjointProfession] = useState<string>("") // 9
  const [num_Child, setNumChild] = useState("") // 10
  const [militarySituation, setMilitarySituation] = useState("") // 11 Militaire
  const [highSchoolAccomplishments, setHighSchoolAccomplishments] = useState("") // 12
  const [educationalAchievements, setEducationalAchievements] = useState("") // 13
  const [dentalSchoolInformation, setDentalSchoolInformation] = useState("") // 14

  // 15
  const [period, setPeriod] = useState("")
  const [yearsOfSuccessfulStudy, setYearsOfSuccessfulStudy] = useState("")
  const [dateOfGraduation, setDateOfGraduation] = useState(formattedDate(new Date().toString()))
  const [placeOfGraduation, setPlaceOfGraduation] = useState("")
  const [type, setType] = useState("")
  
  // 16
  const [universityHospitalTitles, setUniversityHospitalTitles] = useState("")

  // 17
  const [advancedQualifications, setAdvancedQualifications] = useState("")
  // 18 
  const [specialtyQualificationStatus, setSpecialtyQualificationStatus] = useState("")
  // 19
  const [supplementaryUniversityCertifications, setSupplementaryUniversityCertifications] = useState("")
  // 20
  const [distinctionsAndHonoraryTitles, setDistinctionsAndHonoraryTitles] = useState("")
  // 21
  const [otherUniversityDegrees, setOtherUniversityDegrees] = useState("")
  // 22
  const [specialtyCertificateInProgress, setSpecialtyCertificateInProgress] = useState("") // 22
  
  const [publicServiceOrMilitaryRecruitment, setPublicServiceOrMilitaryRecruitment] = useState(formattedDate(new Date().toString())) // 23 - 1
  const [privateSectorEmploymentInMauritania, setPrivateSectorEmploymentInMauritania] = useState(formattedDate(new Date().toString())) // 23 - 2
  const [foreignProfessionalPracticeInMauritania, setForeignProfessionalPracticeInMauritania] = useState(formattedDate(new Date().toString())) // 23 - 3

  const [modeOfExercise, setModeOfExercise] = useState("") // 24 Salaire exclusif
  const [salaryType, setSalaryType] = useState("") // 25 Etat
  const [employerName, setEmployerName] = useState("") // 25

  const [status, setStatus] = useState("") // 26 status of foreign doctor
  const [country, setCountry] = useState("") // 26 country of foreign doctor

  const [workInPublicSector, setWorkInPublicSector] = useState("") // 27
  const [practiceInPrivateMedicine, setPracticeInPrivateMedicine] = useState("")
  const [privatePracticeAuthorization, setPrivatePracticeAuthorization] = useState("")
  const [workPracticeIn, setWorkPracticeIn] = useState("")
  const [remplacements, setRemplacements] = useState("")
  const [practiceHealthcareDiagnosis, setPracticeHealthcareDiagnosis] = useState("")
  const [siNon, setSiNon] = useState("")
  const [activityMedicine, setActivityMedicine] = useState<string | boolean>(false)
  const [paramedical, setParamedical] = useState<string | boolean>(false)
  const [otherActivities, setOtherActivities] = useState("")
  const [association, setAssociation] = useState<string | boolean>(false)
  const [interestInOrganizations, setInterestInOrganizations] = useState<string | boolean>(false)
  const [contract, setContract] = useState("")
  const [contractCommunicationCompliance, setContractCommunicationCompliance] = useState("")
  const [organizationsSeekingCollaboration, setOrganizationsSeekingCollaboration] = useState<string | boolean>(false)
  const [languages, setLanguages] = useState<string | boolean>(false)
  const [refusedRegistration, setRefusedRegistration] = useState<string | boolean>(false)
  const [regOrderList, setRegOrderList] = useState<string | boolean>(false)
  const [otherCountries, setOtherCountries] = useState<string | boolean>(false)
  const [jurisdictionalPenalties, setJurisdictionalPenalties] = useState<string | boolean>(false)
  const [criminalCivilConvictions, setCriminalCivilConvictions] = useState<string | boolean>(false)
  const [judicialDisciplinaryActions, setJudicialDisciplinaryActions] = useState<string | boolean>(false)

  const [selectedRegForm, setSelectedRegForm] = useState<RegistrationForm>(DefaultRegistrationForm)

  useEffect(() => {
    setSelectedRegForm(regForms.find((regForm: RegistrationForm) => regForm.doctor._id === doctorId) ?? DefaultRegistrationForm)
  }, [regForms, doctorId])

  useEffect(() => {
    setPracticeLocations(selectedRegForm.practiceLocations)
    setMaritalStatus(selectedRegForm.maritalStatus)

    setConjointDateOfBirth(formattedDate(selectedRegForm.conjoint?.dateOfBirth))
    setConjointPlaceOfBirth(selectedRegForm.conjoint?.placeOfBirth)
    setConjointProfession(selectedRegForm.conjoint?.profession)
    
    setNumChild(selectedRegForm.num_Child)
    setMilitarySituation(selectedRegForm.militarySituation)
    setHighSchoolAccomplishments(selectedRegForm.highSchoolAccomplishments)
    setEducationalAchievements(selectedRegForm.educationalAchievements)
    setDentalSchoolInformation(selectedRegForm.dentalSchoolInformation)

    setPeriod(selectedRegForm.dentalMedicineDegree?.period)
    setYearsOfSuccessfulStudy(selectedRegForm.dentalMedicineDegree?.yearsOfSuccessfulStudy)
    setDateOfGraduation(formattedDate(selectedRegForm.dentalMedicineDegree?.dateOfGraduation))
    setPlaceOfGraduation(selectedRegForm.dentalMedicineDegree?.placeOfGraduation)
    setType(selectedRegForm.dentalMedicineDegree?.type)

    setUniversityHospitalTitles(selectedRegForm.universityHospitalTitles)
    setAdvancedQualifications(selectedRegForm.advancedQualifications)
    setSpecialtyQualificationStatus(selectedRegForm.specialtyQualificationStatus)
    setSupplementaryUniversityCertifications(selectedRegForm.supplementaryUniversityCertifications)
    setDistinctionsAndHonoraryTitles(selectedRegForm.distinctionsAndHonoraryTitles)
    setOtherUniversityDegrees(selectedRegForm.otherUniversityDegrees)
    setSpecialtyCertificateInProgress(selectedRegForm.specialtyCertificateInProgress)
    setPublicServiceOrMilitaryRecruitment(formattedDate(selectedRegForm.specificDateInformation?.publicServiceOrMilitaryRecruitment))
    setPrivateSectorEmploymentInMauritania(formattedDate(selectedRegForm.specificDateInformation?.privateSectorEmploymentInMauritania))
    setForeignProfessionalPracticeInMauritania(formattedDate(selectedRegForm.specificDateInformation?.foreignProfessionalPracticeInMauritania))

    setModeOfExercise(selectedRegForm.modeOfExercise)
    setSalaryType(selectedRegForm.salariedMedicalPractitioner?.salaryType)
    setEmployerName(selectedRegForm.salariedMedicalPractitioner?.employerName)
    setStatus(selectedRegForm.foreignDoctor?.status)
    setCountry(selectedRegForm.foreignDoctor?.country)
    setWorkInPublicSector(selectedRegForm.workInPublicSector)

    setPracticeInPrivateMedicine(selectedRegForm.practiceInPrivateMedicine)
    setPrivatePracticeAuthorization(selectedRegForm.privatePracticeAuthorization)
    setWorkPracticeIn(selectedRegForm.workPracticeIn)
    setRemplacements(selectedRegForm.remplacements)
    setPracticeHealthcareDiagnosis(selectedRegForm.practiceHealthcareDiagnosis)
    setSiNon(selectedRegForm.siNon)
    setActivityMedicine(selectedRegForm.activityMedicine)
    setParamedical(selectedRegForm.paramedical)
    setOtherActivities(selectedRegForm.otherActivities)
    setAssociation(selectedRegForm.association)
    setInterestInOrganizations(selectedRegForm.interestInOrganizations)
    setContract(selectedRegForm.contract)
    setContractCommunicationCompliance(selectedRegForm.contractCommunicationCompliance)
    setOrganizationsSeekingCollaboration(selectedRegForm.organizationsSeekingCollaboration)
    setLanguages(selectedRegForm.languages)
    setRefusedRegistration(selectedRegForm.refusedRegistration)
    setRegOrderList(selectedRegForm.regOrderList)
    setOtherCountries(selectedRegForm.otherCountries)
    setJurisdictionalPenalties(selectedRegForm.jurisdictionalPenalties)
    setCriminalCivilConvictions(selectedRegForm.criminalCivilConvictions)
    setJudicialDisciplinaryActions(selectedRegForm.judicialDisciplinaryActions)
    
  }, [selectedRegForm])


  const [doctorOptions, setDoctorOptions] = useState<any>([])

  useEffect(() => {
    const findCabinet: DoctorInterface | any = doctors.find((doctor: DoctorInterface) => doctor._id === doctorId)
    setDoctorOptions(doctors
      ?.filter((doctor: DoctorInterface) => doctor.cabinet?._id === findCabinet.cabinet?._id && doctor?._id !== doctorId)
      ?.map((doctor: DoctorInterface) => ({ value: doctor?._id, label: doctor?.fullName })))
  }, [doctors, doctorId])

  const dispatch: any = useDispatch()
  const [loading, setLoading] = useState(false);
  const { setShowSuccessMsg } = useContext(AboutDoctorContext)
  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    let dentalMedicineDegree: any = JSON.stringify({
      period,
      yearsOfSuccessfulStudy,
      dateOfGraduation,
      placeOfGraduation,
      type,
    })
    let salariedMedicalPractitioner: any = JSON.stringify({
      salaryType,
      employerName
    })
    let foreignDoctor = JSON.stringify({
      status,
      country
    })
    let specificDateInformation: any  = JSON.stringify({
      publicServiceOrMilitaryRecruitment,
      privateSectorEmploymentInMauritania,
      foreignProfessionalPracticeInMauritania
    })
    let contact: any = JSON.stringify({
      phone: telephone,
      whatsapp,
      email,
    })

    try {
      const formData: any = new FormData()
      formData.append("doctor", doctorId)

      formData.append("RegNo", RegNo)
      formData.append("fullName", fullName)
      formData.append("yearOfBirth", yearOfBirth)
      formData.append("placeOfBirth", placeOfBirth)
      formData.append("sex", sex)
      formData.append("contact", contact)
      formData.append("nationality", JSON.stringify({
        origin,
        current
      }))
      formData.append("medecinType", medecinType)
      formData.append("inscriptionDate", inscriptionDate)
      formData.append("avatar", avatar)
      formData.append("password", password)
      formData.append("speciality", speciality)
      formData.append("cabinet", cabinet?.value)
      
      formData.append("practiceLocations",practiceLocations)
      formData.append("maritalStatus",maritalStatus)
      formData.append("conjoint", JSON.stringify({
        dateOfBirth: conjointDateOfBirth,
        placeOfBirth: conjointPlaceOfBirth,
        profession: conjointProfession,
      }))
      formData.append("num_Child",num_Child)
      formData.append("militarySituation",militarySituation)
      formData.append("highSchoolAccomplishments",highSchoolAccomplishments)
      formData.append("educationalAchievements",educationalAchievements)
      formData.append("dentalSchoolInformation",dentalSchoolInformation)
      formData.append("dentalMedicineDegree",dentalMedicineDegree)
      formData.append("universityHospitalTitles",universityHospitalTitles)
      formData.append("advancedQualifications",advancedQualifications)
      formData.append("specialtyQualificationStatus",specialtyQualificationStatus)
      formData.append("supplementaryUniversityCertifications",supplementaryUniversityCertifications)
      formData.append("distinctionsAndHonoraryTitles",distinctionsAndHonoraryTitles)
      formData.append("otherUniversityDegrees",otherUniversityDegrees)
      formData.append("specialtyCertificateInProgress",specialtyCertificateInProgress)      
      formData.append("specificDateInformation",specificDateInformation)
      formData.append("modeOfExercise",modeOfExercise)
      formData.append("salariedMedicalPractitioner",salariedMedicalPractitioner)
      formData.append("foreignDoctor",foreignDoctor)
      formData.append("workInPublicSector",workInPublicSector)
      formData.append("practiceInPrivateMedicine",practiceInPrivateMedicine)
      formData.append("privatePracticeAuthorization",privatePracticeAuthorization)
      formData.append("workPracticeIn",workPracticeIn)
      formData.append("remplacements",remplacements)
      formData.append("practiceHealthcareDiagnosis",practiceHealthcareDiagnosis)
      formData.append("siNon",siNon)
      formData.append("activityMedicine",activityMedicine)
      formData.append("paramedical",paramedical)
      formData.append("otherActivities",otherActivities)
      formData.append("association",association)
      formData.append("interestInOrganizations",interestInOrganizations)
      formData.append("contract",contract)
      formData.append("contractCommunicationCompliance",contractCommunicationCompliance)
      formData.append("organizationsSeekingCollaboration",organizationsSeekingCollaboration)
      formData.append("languages",languages)
      formData.append("refusedRegistration",refusedRegistration)
      formData.append("regOrderList",regOrderList)
      formData.append("otherCountries",otherCountries)
      formData.append("jurisdictionalPenalties",jurisdictionalPenalties)
      formData.append("criminalCivilConvictions",criminalCivilConvictions)
      formData.append("judicialDisciplinaryActions",judicialDisciplinaryActions)
      const response = await dispatch(EditRegFormApi(selectedRegForm._id, doctorId, formData))
      if(response === true) {
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout)
        await dispatch(getDoctorsApi())
      }
    } finally {
      setLoading(false)
    }
  }


  return (
    <RegistrationFormContext.Provider value={{
      RegNo, setRegNo,
      fullName, setFullName,
      yearOfBirth, setYearOfBirth,
      placeOfBirth, setPlaceOfBirth,
      sex, setSex,
      telephone, setTelephone,
      whatsapp, setWhatsapp,
      email, setEmail,
      current, setCurrent,
      medecinType, setMedecinType,
      origin, setOrigin,
      inscriptionDate, setInscriptionDate,
      avatar, setAvatar,
      password, setPassword,
      speciality, setSpeciality,
      cabinet, setCabinet,

      practiceLocations, setPracticeLocations,
      maritalStatus, setMaritalStatus,
      
      conjointDateOfBirth, setConjointDateOfBirth,
      conjointPlaceOfBirth, setConjointPlaceOfBirth,
      conjointProfession, setConjointProfession,

      num_Child, setNumChild,
      militarySituation, setMilitarySituation,
      highSchoolAccomplishments, setHighSchoolAccomplishments,
      educationalAchievements, setEducationalAchievements,
      dentalSchoolInformation, setDentalSchoolInformation,
      // 15
      period, setPeriod,
      yearsOfSuccessfulStudy, setYearsOfSuccessfulStudy,
      dateOfGraduation, setDateOfGraduation,
      placeOfGraduation, setPlaceOfGraduation,
      type, setType,
      // 16
      universityHospitalTitles, setUniversityHospitalTitles,
      // 17
      advancedQualifications, setAdvancedQualifications,
      // 18
      specialtyQualificationStatus, setSpecialtyQualificationStatus,
      // 19
      supplementaryUniversityCertifications, setSupplementaryUniversityCertifications,
      // 20
      distinctionsAndHonoraryTitles, setDistinctionsAndHonoraryTitles,
      // 21
      otherUniversityDegrees, setOtherUniversityDegrees,
      // 22
      specialtyCertificateInProgress, setSpecialtyCertificateInProgress,
      // 23
      publicServiceOrMilitaryRecruitment, setPublicServiceOrMilitaryRecruitment,
      privateSectorEmploymentInMauritania, setPrivateSectorEmploymentInMauritania,
      foreignProfessionalPracticeInMauritania, setForeignProfessionalPracticeInMauritania,
      // 24
      modeOfExercise, setModeOfExercise,
      // 25
      salaryType, setSalaryType,
      employerName, setEmployerName,
      // 26
      status, setStatus,
      country, setCountry,
      // 27
      workInPublicSector, setWorkInPublicSector,
      // 28
      practiceInPrivateMedicine, setPracticeInPrivateMedicine,
      // 29
      privatePracticeAuthorization, setPrivatePracticeAuthorization,
      // 30
      workPracticeIn, setWorkPracticeIn,
      // 31
      remplacements, setRemplacements,
      // 32
      practiceHealthcareDiagnosis, setPracticeHealthcareDiagnosis,
      // 33
      siNon, setSiNon,
      // 34
      activityMedicine, setActivityMedicine,
      // 35
      paramedical, setParamedical,
      // 36
      otherActivities, setOtherActivities,
      // 37
      association, setAssociation,
      // 38
      interestInOrganizations, setInterestInOrganizations,
      // 39
      contract, setContract,
      // 40
      contractCommunicationCompliance, setContractCommunicationCompliance,
      // 41
      organizationsSeekingCollaboration, setOrganizationsSeekingCollaboration,
      // 42
      languages, setLanguages,
      // 43
      refusedRegistration, setRefusedRegistration,
      // 44
      regOrderList, setRegOrderList,
      // 45
      otherCountries, setOtherCountries,
      // 46
      jurisdictionalPenalties, setJurisdictionalPenalties,
      // 47
      criminalCivilConvictions, setCriminalCivilConvictions,
      // 48
      judicialDisciplinaryActions, setJudicialDisciplinaryActions,

      doctorOptions, setDoctorOptions
    }}>
    <form encType='multipart/form-data' className='p-4 rounded shadow-lg bg-white' onSubmit={handleSubmit}>
      <ButtonElement type="submit" className='mb-2 font-bold' loading={loading} typeBtn='Modifier' />
      <HeaderRegForm />
      <div className='grid md:grid-cols-2 gap-2'>
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
        <Section5 />
        <Section6 />
        <Section7 />
        <Section8 />
        <Section9 />
        <Section10 />
        <Section11 />
        <Section12 />
        <Section13 />
      </div>
      <ButtonElement type="submit" className='mb-2 font-bold' loading={loading} typeBtn='Modifier' />
    </form>
  </RegistrationFormContext.Provider>
  )
}

export default RegistrationFormComponent